import React from 'react'

import { fetchRmApprovalAccess } from 'api/procurement'

// R&M approval (outside budget) tabs show only for Azam + super admins
// (Satya, 5 Nov 2026). The backend decides and enforces; this only hides the
// tab. One fetch per page load.
let cached = null

export const useRmApprovalAccess = () => {
  const [allowed, setAllowed] = React.useState(cached === true)
  React.useEffect(() => {
    let alive = true
    if (!cached) cached = fetchRmApprovalAccess().catch(() => false)
    Promise.resolve(cached).then((ok) => {
      if (alive) setAllowed(Boolean(ok))
    })
    return () => {
      alive = false
    }
  }, [])
  return allowed
}
